import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addPaymentToLoanBeneficiary,
  fetchAllLoanBeneficiariesLs,
  fetchPaymentByLoanBeneficiaryId,
  makeRequestLoanStatus,
  restoreLoanStatusInitial,
  fetchPaymentByPaymentId,
  fetchLoanBeneficiaryById,
} from "../../Actions";

import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
// import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import MUIDataTable from "mui-datatables";
import OutlinedInput from "@mui/material/OutlinedInput";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import ViewDialogThreePart from "../Global/ViewDialogThreePart";
import { styled } from "@mui/material/styles";
import moment from "moment";
import { CircularProgress } from "@mui/material";
import LoadingOverlay from "react-loading-overlay-ts";
import Chart from "react-apexcharts";

const styleClasses = {
  label: {
    // fontSize: "large",
  },
  sublabel: {
    fontSize: "smaller",
    color: "#555555",
  },
  addPaymentGrid: {
    flexDirection: "column",
  },
  uploadArea: {
    backgroundColor: "#e3e3e3",
    color: "#434343",
    height: "15rem",
    textTransform: "none",
    fontFamily: "Poppins",
    fontSize: "1.05rem",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    ":hover": {
      bgcolor: "#b3b3b3 !important",
    },
  },
  addPaymentContentContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "2rem",
    minWidth: "40rem",
    paddingTop: "1rem",
  },
  addPaymentTitleContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  partTwoContainer: {
    border: "1px solid #c3bdbd",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: ".5rem",
    borderRadius: "5px",
  },
  partTwoContainerError: {
    border: "1px solid #D32F2F",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: ".5rem",
    borderRadius: "5px",
  },
  fileMetaContainer: {
    padding: "10px",
    fontSize: "19px",
  },
  fileActionsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    maxWidth: "fit-content",
  },
};

const RootTableRow = styled("tr")({
  "& .MuiTableCell-root": {
    padding: "4px 16px", // adjust the padding of table cells
  },
  "& .MuiTableRow-root": {
    height: "30px", // set the height of each row
  },
});

const CMProfile = ({ lbData }) => {
  const dispatch = useDispatch();
  const lbPaymentReducer = (state) => state.loanStatusReducer;

  const { lbPaymentAddedSuccessfully, fetchedLoanBeneficiaryByIdData } =
    useSelector(lbPaymentReducer);

  const processedData = [
    [
      {
        label: "Name",
        value: lbData?.cmName,
      },
      {
        label: "State Code",
        value: lbData?.cmStateCode,
      },
    ],
    [
      {
        label: "Loan Name",
        value: lbData?.loan?.name,
      },
      {
        label: "Loan Amount",
        value: `₦ ${new Intl.NumberFormat().format(lbData?.loan?.amount)}`,
      },
    ],
    [
      {
        label: "Amount Paid",
        value: `₦ ${new Intl.NumberFormat().format(lbData?.totalAmountPaid)}`,
      },
      {
        label: "Loan Balance",
        value: `₦ ${new Intl.NumberFormat().format(lbData?.loan?.amount - lbData?.totalAmountPaid)}`,// ben.loan.amount - ben.totalAmountPaid,
      }
    ]
  ];

  const [donutChartData, setDonutChartData] = useState({
    options: {
      colors: ["#65BA8E", "#F54B4B"],
      labels: ["Total Amount Paid", "Total Amount Remaining"],
      legend: {
        position: "bottom",
      },
      tooltip: {
        x: {
          formatter: function (value) {
            const figure = new Intl.NumberFormat().format(value);
            return `₦ ${figure}`;
          },
        },
        y: {
          formatter: function (value) {
            const figure = new Intl.NumberFormat().format(value);
            return `₦ ${figure}`;
          },
        },
      },
    },
    series: [
      lbData?.totalAmountPaid,
      lbData.loan?.amount - lbData?.totalAmountPaid,
    ],
  });

  useEffect(() => {
    if (lbPaymentAddedSuccessfully === true)
      dispatch(fetchLoanBeneficiaryById({ LoanBeneficiaryId: lbData.id }));
  }, [lbPaymentAddedSuccessfully]);

  useEffect(() => {
    if (Object.keys(fetchedLoanBeneficiaryByIdData).length > 0) {
      setDonutChartData({
        ...donutChartData,
        series: [
          fetchedLoanBeneficiaryByIdData?.totalAmountPaid,
          fetchedLoanBeneficiaryByIdData?.loan.amount -
            fetchedLoanBeneficiaryByIdData?.totalAmountPaid,
        ],
      });
    }
  }, [fetchedLoanBeneficiaryByIdData]);

  return (
    <Grid container direction="column" style={{ paddingTop: "2rem" }}>

      {/* CM Metadata */}
      <Grid
        item
        xs
        container
        direction="column"
        spacing={2}
      >
        {processedData.map((row) => {
          return (
            <Grid
              item
              xs
              container
              direction="row"
              key={row[0].value}
              spacing={3}
              style={{
                margin: 0,
                maxHeight: "150px",
              }}
            >
              {row.map((field) => {
                return (
                  <Grid
                    item
                    xs
                    style={{
                      display: "flex",
                      width: "20rem",
                      paddingTop: "0",
                    }}
                    key={`${field.value}+${field.label}`}
                  >
                    <TextField
                      value={field.value}
                      label={field.label}
                      variant="standard"
                      color="primary"
                      fullWidth
                      size="small"
                      style={{
                        display: "flex",
                      }}
                      disabled
                      InputProps={{
                        disableUnderline: true,
                        style: { border: "none" },
                        sx: {
                          "& .MuiInputBase-input": {
                            color: "black !important",
                            WebkitTextFillColor: "black !important",
                          },
                        },
                      }}
                    />
                  </Grid>
                );
              })}
            </Grid>
          );
        })}
      </Grid>
      <Divider />
      {/* Donut chart */}
      <Grid style={{ padding: "24px" }}>
        <div className="donut">
          <Chart
            // options={{}}
            options={donutChartData.options}
            series={donutChartData.series}
            type="donut"
            width="300"
          />
        </div>
      </Grid>
    </Grid>
  );
};

const CMPaymentHistory = ({ lbData, dialogIsOpen, tablePaginationData }) => {
  const dispatch = useDispatch();
  const lbPaymentReducer = (state) => state.loanStatusReducer;

  const {
    lbPaymentAddedSuccessfully,
    lbAddingPayment,
    fetchingPaymentsForLB,
    listOfPaymentsForOneLB,
    particularPaymentToBeViewed,
    fetchingparticularPaymentToBeViewed,
    fetchedLoanBeneficiaryByIdData,
  } = useSelector(lbPaymentReducer);

  const [paymentHistory, setPaymentHistory] = useState([]);
  const [viewReceiptDialogIsOpen, setViewReceiptDialogIsOpen] = useState(false);
  const [addPaymentDialogIsOpen, setAddPaymentDialogIsOpen] = useState(false);
  const [paymentReceipt, setPaymentReceipt] = useState("");
  const [showUploadReceiptSecondMode, setShowUploadReceiptSecondMode] =
    useState(false);
  const [newPaymentData, setNewPaymentData] = useState({
    paymentAmount: "",
    lbId: 0,
    fileName: "",
    fileSize: 0,
    fileContent: "",
    selectedFile: null,
  });
  const [fileUploadErrorHolder, setFileUploadErrorHolder] = useState({
    isFileUploaded: false,
    isFileSizeValid: false,
    errorText: "Payment Receipt is required",
  });
  const [currencyErrorHolder, setCurrencyErrorHolder] = useState({
    error: true,
    errorText: "Payment Amount is required",
  });

  const [showErrors, setShowErrors] = useState({
    currency: false,
    paymentReceipt: false,
  });

  const [currentLoanPaymentStatus, setCurrentLoanPaymentStatus] = useState({
    totalLoanAmount: lbData.loan?.amount,
    totalAmountPaid: lbData?.totalAmountPaid,
  });

  const openViewReceiptDialog = (paymentId) => {
    setViewReceiptDialogIsOpen(true);
    dispatch(fetchPaymentByPaymentId(paymentId));
  };

  const openAddPaymentDialog = () => {
    setAddPaymentDialogIsOpen(true);
    setNewPaymentData({
      ...newPaymentData,
      lbId: lbData.id,
    });
  };

  const handleCloseViewReceiptDialog = () => {
    setViewReceiptDialogIsOpen(false);
    setPaymentReceipt("");
  };

  const handleCloseAddPaymentDialog = () => {
    setAddPaymentDialogIsOpen(false);

    // resets
    setShowUploadReceiptSecondMode(false);
    setNewPaymentData({
      paymentAmount: "",
      lbId: 0,
      fileName: "",
      fileSize: 0,
      fileContent: "",
      selectedFile: null,
    });
    setFileUploadErrorHolder({
      isFileUploaded: false,
      isFileSizeValid: false,
      errorText: "Payment Receipt is required",
    });
    setCurrencyErrorHolder({
      error: true,
      errorText: "Payment Amount is required",
    });
    setShowErrors({
      currency: false,
      paymentReceipt: false,
    });
  };

  const handleFileSelect = ({ target }) => {
    setShowUploadReceiptSecondMode(true);
    setShowErrors({
      ...showErrors,
      paymentReceipt: true,
    });
    const uploadedFile = target.files[0];

    // instantiate file reader
    const reader = new FileReader();

    // attach event handler to reader load event
    // https://developer.mozilla.org/en-US/docs/Web/API/FileReader/load_event
    reader.onload = (e) => {
      if (uploadedFile.size > 2097152) {
        setFileUploadErrorHolder({
          isFileUploaded: true,
          isFileSizeValid: false,
          errorText: "File size must be less than 2MB",
        });
      } else if (uploadedFile.size <= 2097152) {
        setFileUploadErrorHolder({
          isFileUploaded: true,
          isFileSizeValid: true,
          errorText: "",
        });
      }

      setNewPaymentData({
        ...newPaymentData,
        fileContent: e.target.result,
        fileName: uploadedFile.name,
        fileSize: uploadedFile.size,
        selectedFile: uploadedFile,
      });
    };

    // convert file to base64
    reader.readAsDataURL(uploadedFile);
  };

  const handleRemoveUploadedFile = () => {
    setShowUploadReceiptSecondMode(false);

    setNewPaymentData({
      ...newPaymentData,
      fileName: "",
      fileSize: 0,
      fileContent: "",
      selectedFile: null,
    });

    setFileUploadErrorHolder({
      isFileUploaded: false,
      isFileSizeValid: false,
      errorText: "Payment Receipt is required",
    });
  };

  const approxFileSize = (numberOfBytes) => {
    const units = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const exponent = Math.min(
      Math.floor(Math.log(numberOfBytes) / Math.log(1024)),
      units.length - 1
    );
    const approx = numberOfBytes / 1024 ** exponent;
    const output =
      exponent === 0
        ? `${numberOfBytes} bytes`
        : `${approx.toFixed(3)} ${units[exponent]}`;
    return output;
  };

  /**
   * Checks if `inputValue` is a valid currency (number).
   * ### Examples:
   * - Empty character: `''` -> `''`
   * - `'1111'` -> `'1111'`
   * - `'2222e'` -> `'2222'`
   * - `'f'` -> `false`
   * @param {string | number} inputValue
   * @returns {string | boolean} Returns same inputValue if it passes checks, returns false if otherwise
   */
  const validateCurrencyField = (inputValue) => {
    if (inputValue === "") {
      setCurrencyErrorHolder({
        ...currencyErrorHolder,
        error: true,
        errorText: "Payment Amount is required",
      });
      return inputValue;
    } else {
      let formattedValue = Number.parseInt(inputValue, 10); // convert to a number
      if (Boolean(formattedValue)) {
        //
        return formattedValue;
      } else return false;
    }
  };

  const handleCurrencyFieldOnChange = (value) => {
    const isValid = validateCurrencyField(value);

    setShowErrors({
      ...showErrors,
      currency: true,
    });

    if (isValid !== false) {
      // do a state reset here, for the '' character
      setCurrencyErrorHolder({
        ...currencyErrorHolder,
        error: false,
        errorText: "",
      });

      setNewPaymentData({
        ...newPaymentData,
        paymentAmount: isValid,
      });

      const newTotalAmountPaid =
        isValid + currentLoanPaymentStatus.totalAmountPaid;

      if (newTotalAmountPaid > currentLoanPaymentStatus.totalLoanAmount) {
        setCurrencyErrorHolder({
          ...currencyErrorHolder,
          error: true,
          errorText: "Payment Amount cannot be larger than the Loan Amount",
        });
      } else if (isValid === "") {
        setCurrencyErrorHolder({
          ...currencyErrorHolder,
          error: true,
          errorText: "Payment Amount is required",
        });
        setShowErrors({
          ...showErrors,
          currency: false,
        });
      }
    }
  };

  const handleSubmitNewPayment = () => {
    const isAmountValid = !currencyErrorHolder.error;
    const isFileUploaded = fileUploadErrorHolder.isFileUploaded;
    const isFileSizeValid = fileUploadErrorHolder.isFileSizeValid;

    const clearForSubmission =
      isAmountValid && isFileUploaded && isFileSizeValid;

    setShowErrors({
      ...showErrors,
      currency: true,
      paymentReceipt: true,
    });

    if (clearForSubmission) {
      // fire this only when validation is complete
      dispatch(
        addPaymentToLoanBeneficiary({
          AmountPaid: newPaymentData.paymentAmount,
          LoanBeneficiaryId: newPaymentData.lbId,
          file: newPaymentData.selectedFile,
        })
      );
    }
  };

  const columns = [
    {
      name: "sn",
      label: "S/N",
    },
    {
      name: "dateOfPayment",
      label: "Date of Payment",
      options: {
        customBodyRender: (value) => {
          return moment(value).format("DD/MM/YYYY");
        },
      },
    },
    {
      name: "amountPaid",
      label: "Amount Paid",
      options: {
        customBodyRender: (value) => {
          const amountPaid = new Intl.NumberFormat().format(value);
          return `₦ ${amountPaid}`;
        },
      },
    },
    {
      name: "proofOfPayment",
      label: "Proof of Payment",
      options: {
        customBodyRender: (value) => {
          return (
            <Button onClick={() => openViewReceiptDialog(value)}>
              View Receipt
            </Button>
          );
        },
      },
    },
  ];

  const options = {
    selectableRows: "none",
    print: false,
    viewColumns: false,
    sort: false,
    filter: false,
    search: false,
    download: false,
    setRowProps: (row, dataIndex) => {
      return { component: RootTableRow };
    },
    customToolbar: () => {
      // const cmLoanPaymentComplete =
      //   currentLoanPaymentStatus.totalAmountPaid ===
      //   currentLoanPaymentStatus.totalLoanAmount;

      return (
        <>
          {/* {!cmLoanPaymentComplete && ( */}
          <Button variant="contained" onClick={() => openAddPaymentDialog()}>
            Loan Settlement
          </Button>
          {/* )} */}
        </>
      );
    },
    textLabels: {
      body: {
        noMatch: "Loan Beneficiary has not made any payment",
        toolTip: "Sort",
        columnHeaderTooltip: (column) => `Sort for ${column.label}`,
      },
    },
  };

  useEffect(() => {
    // runs when payment is added successfully
    if (lbPaymentAddedSuccessfully) {
      handleCloseAddPaymentDialog();
      dispatch(
        fetchPaymentByLoanBeneficiaryId({
          loanBeneficiaryId: lbData.id,
        })
      );
      dispatch(restoreLoanStatusInitial());
      dispatch(fetchAllLoanBeneficiariesLs({...tablePaginationData }));
      dispatch(makeRequestLoanStatus());
    }
  }, [lbPaymentAddedSuccessfully]);

  useEffect(() => {
    // populates the payment history with data from API
    if (listOfPaymentsForOneLB) {
      let lbPaymentHistory = [];
      let counter = 1;
      listOfPaymentsForOneLB.map((payment) => {
        lbPaymentHistory.push({
          sn: counter,
          dateOfPayment: payment.dateCreated,
          amountPaid: payment.amountPaid,
          proofOfPayment: payment.id,
        });
        counter += 1;
      });
      setPaymentHistory(lbPaymentHistory.reverse());
      setNewPaymentData({
        ...newPaymentData,
        lbId: lbData.id,
      });
    }
  }, [listOfPaymentsForOneLB]);

  useEffect(() => {
    if (dialogIsOpen === false) {
      setPaymentHistory([]);
    }
  }, [dialogIsOpen]);

  useEffect(() => {
    if (Object.keys(fetchedLoanBeneficiaryByIdData).length > 0) {
      setCurrentLoanPaymentStatus({
        ...currentLoanPaymentStatus,
        totalLoanAmount: fetchedLoanBeneficiaryByIdData.loan.amount,
        totalAmountPaid: fetchedLoanBeneficiaryByIdData.totalAmountPaid,
      });
    }
  }, [fetchedLoanBeneficiaryByIdData]);

  return (
    <div
      style={{
        width: "100%",
        padding: "1rem",
      }}
    >
      {/* MUI Datatable */}
      <div>
        <LoadingOverlay active={fetchingPaymentsForLB}>
          <MUIDataTable
            data={paymentHistory}
            columns={columns}
            options={options}
          />
        </LoadingOverlay>
      </div>

      <Dialog // view receipt dialog
        maxWidth={"md"}
        open={viewReceiptDialogIsOpen}
        onClose={handleCloseViewReceiptDialog}
        PaperProps={{
          style: { borderRadius: "1rem" },
        }}
      >
        <DialogTitle
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          View Receipt
          <IconButton aria-label="Close" onClick={handleCloseViewReceiptDialog}>
            <CloseRoundedIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {fetchingparticularPaymentToBeViewed ? (
            <CircularProgress />
          ) : (
            <img
              src={`data:image/png;base64,${particularPaymentToBeViewed?.file}`} // should not feed directly from the redux store
              alt="Payment Receipt"
            />
          )}
        </DialogContent>
      </Dialog>

      <Dialog // add payment dialog
        maxWidth={"md"}
        open={addPaymentDialogIsOpen}
        onClose={handleCloseAddPaymentDialog}
        PaperProps={{
          style: { borderRadius: "1rem" },
        }}
      >
        <DialogTitle style={styleClasses.addPaymentTitleContainer}>
          Add Payment
          <IconButton
            aria-label="Close"
            onClick={() => handleCloseAddPaymentDialog()}
          >
            <CloseRoundedIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent style={styleClasses.addPaymentContentContainer}>
          <Grid container item xs sx={styleClasses.addPaymentGrid}>
            <FormControl
              fullWidth
              required
              disabled={lbAddingPayment}
              placeholder="Enter amount in figures here"
              error={showErrors.currency === true && currencyErrorHolder.error}
            >
              <InputLabel
                htmlFor="amountInFigures"
                sx={{ fontSize: "19px !important" }}
              >
                Amount in Figures
              </InputLabel>
              <OutlinedInput
                style={{
                  fontSize: "19px",
                }}
                startAdornment={
                  <InputAdornment
                    position="start"
                    sx={{ fontSize: "19px !important" }}
                  >
                    ₦
                  </InputAdornment>
                }
                label="Amount in Figures"
                id="amountInFigures"
                value={
                  newPaymentData.paymentAmount === ""
                    ? ""
                    : new Intl.NumberFormat().format(
                        newPaymentData.paymentAmount
                      )
                }
                onChange={(event) => {
                  const unformattedValue = event.target.value.replace(/,/g, "");
                  handleCurrencyFieldOnChange(unformattedValue);
                }}
              />
              <FormHelperText>
                {showErrors.currency === true && currencyErrorHolder.errorText}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid container item xs sx={styleClasses.addPaymentGrid}>
            <Typography
              sx={styleClasses.label}
              style={{
                color:
                  showErrors.paymentReceipt &&
                  fileUploadErrorHolder.errorText.length > 0
                    ? "#D32F2F"
                    : "rgba(0, 0, 0, 0.87)",
              }}
            >
              Payment Receipt*
            </Typography>
            {showErrors.paymentReceipt ? (
              fileUploadErrorHolder.errorText.length > 0 ? (
                <Typography
                  sx={styleClasses.sublabel}
                  style={{
                    color:
                      fileUploadErrorHolder.errorText.length > 0 && "#D32F2F",
                  }}
                >
                  {/* (File size must be less than 2MB) */}
                  {fileUploadErrorHolder.errorText}
                </Typography>
              ) : (
                <></>
              )
            ) : (
              <></>
            )}

            {!showUploadReceiptSecondMode ? (
              <Button
                disableElevation
                autoCapitalize="false"
                variant="contained"
                component="label"
                sx={styleClasses.uploadArea}
              >
                <CloudUploadIcon sx={{ fontSize: 40 }} />
                {/* Click or drag file here to upload */}
                Click here to upload file
                <input
                  id="uploadedReceipt"
                  accept="image/*"
                  type="file"
                  hidden
                  onChange={(event) => handleFileSelect(event)}
                />
              </Button>
            ) : (
              <Grid
                container
                item
                xs
                style={
                  fileUploadErrorHolder.error
                    ? styleClasses.partTwoContainerError
                    : styleClasses.partTwoContainer
                }
              >
                <Grid item xs style={styleClasses.fileMetaContainer}>
                  {newPaymentData.fileName} (
                  {approxFileSize(newPaymentData.fileSize)})
                </Grid>
                <Grid item xs style={styleClasses.fileActionsContainer}>
                  {/* <Tooltip title="Preview File">
                    <IconButton>
                      <RemoveRedEyeOutlinedIcon sx={{ fontSize: 28 }} />
                    </IconButton>
                  </Tooltip> */}
                  <Tooltip title="Remove File">
                    <IconButton
                      onClick={
                        !lbAddingPayment && (() => handleRemoveUploadedFile())
                      }
                    >
                      <CloseRoundedIcon sx={{ fontSize: 28 }} />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            )}
          </Grid>
          <DialogActions>
            <Button
              variant="contained"
              disabled={lbAddingPayment}
              onClick={handleSubmitNewPayment}
              sx={{ minWidth: 100 }}
            >
              {lbAddingPayment ? (
                <CircularProgress size={25} sx={{ color: "gray" }} />
              ) : (
                <>Add Payment</>
              )}
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </div>
  );
};

const ViewCMDialog = ({
  isOpen,
  onCloseHandler,
  loanBeneficiaryData,
  tablePaginationData,
}) => {
  const handleClose = () => {
    onCloseHandler();
  };

  return (
    <ViewDialogThreePart
      isOpen={isOpen}
      onCloseHandler={handleClose}
      dialogTitle={"Loan Payment History"}
      columnOneChildren={<CMProfile lbData={loanBeneficiaryData} />}
      columnTwoChildren={
        <CMPaymentHistory
          lbData={loanBeneficiaryData}
          dialogIsOpen={isOpen}
          tablePaginationData={tablePaginationData}
        />
      }
    />
  );
};

export default ViewCMDialog;
